import { ElementNode } from 'lexical';

export class LayoutItemNode extends ElementNode {
    __textStyle: string;

    static getType(): string {
        return 'layout-item';
    }
    static clone(node: LayoutItemNode): LayoutItemNode {
        return new LayoutItemNode(node.__textStyle, node.__key);
    }

    constructor(textStyle: string = '', key?: string) {
        super(key);
        this.__textStyle = textStyle;
    }

    createDOM(): HTMLElement {
        const dom = document.createElement('div');
        dom.className = 'layout-item';
        if (this.__textStyle) {
            const layoutOnly = this.__textStyle
                .split(';')
                .filter((s) => !s.match(/color|background/i)) // dropping color & bg styles, since lexical lift them up from children to parent.
                .join(';');
            if (layoutOnly) {
                dom.setAttribute('style', layoutOnly);
            }
        }
        dom.style.padding = '8px 16px';
        return dom;
    }

    updateDOM(): boolean {
        return true;
    }

    canBeEmpty(): boolean {
        return false;
    }

    isShadowRoot(): boolean {
        return false;
    }

    canInsertTab(): boolean {
        return false;
    }

    canMergeWhenEmpty(): boolean {
        return false;
    }

    static importJSON(serializedNode: any): LayoutItemNode {
        const { textStyle } = serializedNode;
        return new LayoutItemNode(textStyle);
    }

    exportJSON() {
        const base = super.exportJSON();
        const cleanedTextStyle = (this.__textStyle || '').replace(/border\s*:\s*[^;]+;?/gi, '').trim();
        return {
            ...base,
            type: LayoutItemNode.getType(),
            ...(cleanedTextStyle ? { textStyle: cleanedTextStyle } : {})
        };
    }
}
